import React from 'react'
import { Guardian } from '@xaamin/guardian';
import { Badge, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Str from '../../support/Str';
import { Auth } from '../../support';
import NavLink from '../components/NavLink';
import Tenancy from '../../shared/tenancy/Tenancy';
import Loading from '../../facturotopia/loading/Loading';

const AppSidebar = ({ live, busy, onMenuItemClick, onCompanyClick, onTenancyChange, ...rest }) => {
  const { empresa = {} } = Auth.getData() || {};

  const sidebarContainerClassName = 'sidebar-container ' + (!!live ? 'live': '');

  const modulosAdicionalesTarget = (Guardian.allows('facturacion_masiva.access') && '/modulos/timbrado-masivo')
    || (Guardian.allows('autofacturacion.access') && '/modulos/autofacturacion')
    || (Guardian.allows('socios_de_negocio.access') && '/modulos/socios')
    || (Guardian.allows('timbrado_sftp.access') && '/modulos/timbrado-sftp')
    || (Guardian.allows('cancelacion_masiva.access') && '/modulos/cancelaciones/tickets')

  return (
    <div className={ sidebarContainerClassName }>
      <div className="scrollbar">
        <Nav className="flex-column">

          <Nav.Link as="div" eventKey="tenancy" to="#tenancy" className="tenancy-link my-3">
            { busy && <Loading className="mt-3 ml-5" /> }

            { !busy && (
                <Tenancy live={ live } onTenancyChange={ onTenancyChange } />
              )
            }
          </Nav.Link>

          <Nav.Link as="div"
            eventKey="company"
            to="/app/switch"
            className="nav-link-company"
            onClick={ onCompanyClick }
          >
            <div className="company">
              { Str.only(empresa.nombre, 18) }
              <span className="float-right pr-3">
                <FontAwesomeIcon icon={ ['fas', 'exchange-alt'] } />
              </span>
            </div>
          </Nav.Link>

          <Nav.Link eventKey="disabled" disabled className="divider-simple"></Nav.Link>

          { !live && (
            <Nav.Link as={ NavLink } eventKey="into" to="/app/intro" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['fas', 'rocket'] } />
              <span className="nav-link-text">
                INTRO
                <Badge variant="info" className="beta-badge">COMPLETAR</Badge>
              </span>
            </Nav.Link>
          )}

          <Nav.Link as={ NavLink } eventKey="dashboard" to="/app/dashboard" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['fas', 'tachometer-alt'] } />
            <span className="nav-link-text">Dashboard</span>
          </Nav.Link>

          { Guardian.allows('prefacturas.access') && (
            <Nav.Link as={ NavLink } eventKey="prefacturas" to="/app/prefacturas" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['fas', 'file-alt'] } />
              <span className="nav-link-text">Prefacturas</span>
            </Nav.Link>
          )}

          <Nav.Link as={ NavLink } eventKey="comprobantes" to="/app/comprobantes" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['fas', 'file-alt'] } />
            <span className="nav-link-text">Facturas</span>
          </Nav.Link>

          { Guardian.allows('retenciones.access') && (
            <Nav.Link as={ NavLink } eventKey="retenciones" to="/app/retenciones" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'file-alt'] } />
              <span className="nav-link-text">Retenciones</span>
            </Nav.Link>
          )}

          <Nav.Link as={ NavLink } eventKey="emisores" to="/app/emisores" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['far', 'paper-plane'] } />
            <span className="nav-link-text">Emisores</span>
          </Nav.Link>

          { Guardian.allows('receptores.access') && (
            <Nav.Link as={ NavLink } eventKey="receptores" to="/app/receptores" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'user'] } />
              <span className="nav-link-text">Receptores</span>
            </Nav.Link>
          )}

          { Guardian.allows('usuarios.access') && (
            <Nav.Link as={ NavLink } eventKey="usuarios" to="/app/usuarios" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'address-book'] } />
              <span className="nav-link-text">Usuarios</span>
            </Nav.Link>
          )}

          { Guardian.allows('developers.access') && (
            <Nav.Link as={ NavLink } eventKey="developers" to="/developers/timbrado/comprobantes" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['fas', 'code'] } />
              <span className="nav-link-text">
                Developers
                <Badge variant="danger" className="beta-badge">BETA</Badge>
              </span>
            </Nav.Link>
          )}

          <Nav.Link eventKey="disabled" disabled>
            Mi empresa
          </Nav.Link>

          { Guardian.allows('reportes.hits.access') && (
            <Nav.Link as={ NavLink } eventKey="hits" to="/app/consumo-hits" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['fas', 'chart-line'] } />
              <span className="nav-link-text">Hits</span>
            </Nav.Link>
          )}

          { Guardian.allows('modulos_adicionales.access') && (
            <Nav.Link as={ NavLink } eventKey="retenciones" to={ modulosAdicionalesTarget } onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['fas', 'cubes'] } />
              <span className="nav-link-text">Mis módulos</span>
            </Nav.Link>
          )}

        </Nav>
      </div>
    </div>
  )
}

export default AppSidebar
